<div class="read-more " [class.open]="isOpen" [class.is-animated]="isAnimated" [ngStyle]="{'max-height.px': useMaxHeight}">
	<ng-content></ng-content>
</div>
<div class="mt-1 btn btn-link px-0 read-more-btn" (click)="toggleReadMore()">
	<ng-content *ngIf="!isOpen" #readMoreTextBlock select="span.read-more-text"></ng-content>
	<ng-content *ngIf="isOpen" #readLessTextBlock select="span.read-less-text"></ng-content>
	<span class="ml-2">
		<fa-icon *ngIf="isOpen" [icon]="['fas', 'chevron-up']"></fa-icon>
		<fa-icon *ngIf="!isOpen" [icon]="['fas', 'chevron-down']"></fa-icon>
	</span>
</div>
